module.exports = __webpack_public_path__ + "static/media/uncheckmarked.ebfc8e78.svg";